import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOffer, IOfferInitialState } from "./offerModel";
import {
  ActiveInactiveOffer,
  createOffer,
  deleteOffer,
  getAllOffers,
  getOfferByID,
  updateOffer,
  OfferImageUpload,
} from "./services/offer.services";

const initialState: IOfferInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  OfferList: [],
  OfferID: null,
  OfferDetail: {
    ID: null,
    Title: "",
    ShortDescription: "",
    LongDescription: "",
    URL: "",
    MetaTitle: "",
    MetaKeywords: "",
    MetaDescription: "",
    TermsAndCondition: "",
    IsDisplayHome: false,
    IsActive: 1,
  },
};

const offerSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {
    clearOfferDetails: (state) => {
      state.OfferDetail = initialState.OfferDetail;
    },
    setOfferID: (state, action) => {
      state.OfferID = action.payload;
    },
    clearOfferID: (state) => {
      state.OfferID = initialState.OfferID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllOffers.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllOffers.fulfilled,
      (state, action: PayloadAction<IOffer[]>) => {
        state.loading = false;
        state.OfferList = action.payload || [];
      }
    );
    builder.addCase(getAllOffers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.OfferList = [];
    });
    builder.addCase(createOffer.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createOffer.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createOffer.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateOffer.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateOffer.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateOffer.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteOffer.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteOffer.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteOffer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getOfferByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getOfferByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.OfferDetail = action.payload;
    });
    builder.addCase(getOfferByID.rejected, (state, action) => {
      state.formLoading = false;
      state.OfferDetail = initialState.OfferDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(ActiveInactiveOffer.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveOffer.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveOffer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(OfferImageUpload.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(OfferImageUpload.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(OfferImageUpload.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearOfferDetails, clearOfferID, setOfferID } = offerSlice.actions;
export default offerSlice.reducer;
